module.exports = __webpack_public_path__ + "static/about-banner-66a5a2a6c5b608658454b07c63322554.png";